var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){_vm.hideNav()}}},[_c('router-link',{attrs:{"to":_vm.item.url}},[_c('i',{staticClass:"icon material-icons"},[_vm._v(_vm._s(_vm.item.icon))]),_vm._v("\n        "+_vm._s(_vm.item.label)+"\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38881c90","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/nav/NavItem.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-38881c90","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/nav/NavItem.vue
// module chunks = 0